import { render } from "./FormComVue.vue?vue&type=template&id=1b851cab"
import script from "./FormComVue.vue?vue&type=script&lang=js"
export * from "./FormComVue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__